import * as React from "react";
import {Button} from "react-bootstrap";
import IconButton from "../../../components/button/IconButton";
import {Actions} from "../../../../client/Actions";
import { useTranslation } from 'react-i18next';

const columns = (t) => {
    return [
        {
            label: "verificationTable.id",
            field: "id",
            sort: "desc",
            width: 53,
        },
        {
            label: "verificationTable.creationDate",
            field: "creationDate",
            sort: "desc",
            width: 53,
        },
        {
            label: "verificationTable.internalNumber",
            field: "internalNumber",
            sort: "desc",
            width: 53,
            parent: "toolSet"
        },
        {
            field: "toolLabelling",
            label: t("verificationTable.toolLabelling"),
            sort: "desc",
            width: 53,
            parent: "toolSet"

        },
        {
            field: "productName",
            label: "verificationTable.productName",
            sort: "desc",
            width: 53,
            type: "dictionary",
            parent: "toolSet"
        },
        {
            field: "toolsCount",
            label: "verificationTable.toolsCount",
            sort: "desc",
            width: 53,
            parent: "toolSet"
        },
        {
            field: "multipleTool",
            label: "verificationTable.multipleTool",
            sort: "desc",
            width: 53,
            type: "boolean",
            parent: "toolSet"
        },

        {
            field: "completed",
            label: "verificationTable.completed",
            sort: "desc",
            width: 53,
            type: "custom",
            custom: function(column, row, history) {
                return <>
                    {row.completed ?
                      <i className="far fa-check-circle text-primary"></i> :
                      <i className="far fa-times-circle text-secondary"></i>
                    }</>
            }

        },

        {
            field: "actions",
            label: "verificationTable.actions",
            sort: "desc",
            width: 53,
            type: "custom",
            custom: function(column, row, history) {
                return <div className={"d-flex"}>
                    <IconButton
                      variant={"outline-primary"}
                      className="btn-circle ml-1"
                      onClick={() => {
                          history.push("/verification/" + row.id);
                      }}
                      size={"sm"}

                      tooltip={!row.completed ? t("verificationTable.continue") : t("verificationTable.details")}
                      icon={"fa-arrow-right "}
                    />
                    {row.completed &&
                      <>
                          <IconButton
                            icon={"fa-scroll"}
                            variant={"outline-primary"}
                            size={"sm"}
                            className="btn-circle ml-1"
                            onClick={() => {
                                Actions.download(`generate-pdf/measurement/${row.id}`, `verification-${row.id}`);
                            }}
                            tooltip={t("verificationTable.downloadReport")}
                          />
                          {row.configuration.withMeasurements === true &&
                            <IconButton
                              variant={"outline-primary"}
                              className="btn-circle ml-1"
                              onClick={() => {
                                  history.push("/verification/" + row.id + "/pairing");
                              }}
                              size={"sm"}
                              tooltip={t("verificationTable.pairingReport")}
                              icon={"fa-grip-lines"}
                            />
                          }
                      </>
                    }
                </div>
                // <Button as="a" size={"sm"} variant="outline-primary" className="btn-circle ml-1 tableInfoBtn"
                //                role="button"
                //                onClick={() => {
                //                    history.push("/verification/" + row.id);
                //                }}>
                //     <i className="fas fa-arrow-right text-primary"/>
                // </Button>;
            }

        }


    ];
}
export default columns;